import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import AddIcon from '@material-ui/icons/Add';
import {
  getAuthClientDetails,
  getAuthClientList,
  getSelectedAuthClientID,
  showProgress,
} from '../../redux/actions/DealershipActions';
import SideBarListStyle from '../../styles/SideBarListStyle';

import ShowProgress from '../ui/Backdrop';
import FloatButton from './FloatButton';
import AuthAddNewPopup from '../AuthClient/AuthAddNewPopup';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
import { decryptAESJSONData } from '../utils/Utils';

const SideBarListAuth = (props) => {
  const dispatch = useDispatch();
  const classes = SideBarListStyle();
  const value = props.value || 0;
  const fabs = [
    {
      color: 'primary',
      className: classes.fab,
      icon: <AddIcon />,
      label: 'Add',
    },
    {
      color: 'primary',
      className: classes.fab,
      icon: <AddIcon />,
      label: 'Add',
    },
  ];

  const [selectedAuthClientID, setSelectedAuthClientID] = useState('');
  const [IsAddnewAuthPopupOpen, setIsAddnewAuthPopupOpen] = useState(false);
  useEffect(() => {
    getClientList();
  }, []);
  const addNewAuth = () => {
    setIsAddnewAuthPopupOpen(true);
  };
  const closeAddNewAuth = () => {
    setIsAddnewAuthPopupOpen(false);
  };
  const getClientList = async () => {
    await service
      .get(apiEndpoints.AUTH_APP_AUTHENTICATION)
      .then((response) => {
        dispatch(getAuthClientList('add', response));
        setSelectedAuthClientID(response[0].id);
        handleListItemClick(0, response[0].id);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const myRefs = props.filterArray?.reduce((acc, val) => {
    acc[val.id] = React.createRef();
    return acc;
  }, {});

  useEffect(() => {
    if (!_isEmpty(myRefs) && myRefs[selectedAuthClientID]) {
      myRefs[selectedAuthClientID]?.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, [selectedAuthClientID, props.filterArray]);

  const handleListItemClick = async (event, id) => {
    setSelectedAuthClientID(id);
    dispatch(getSelectedAuthClientID(id));
    dispatch(showProgress(true));
    await service
      .get(apiEndpoints.AUTH_UPDATE_AUTHENTICATION.replace('AUTH_CLIENT_ID', id))
      .then((response) => {
        const decryptedData = decryptAESJSONData(response, process.env.REACT_APP_ENCRYPT_REQUEST_KEY);
        dispatch(getAuthClientDetails(decryptedData));
        dispatch(showProgress(false));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
      });
  };
  return (
    <div className={classes.root} id="sidebar_list_badge" style={{ marginTop: '3vh' }}>
      <List component="nav" aria-label="secondary mailbox folder">
        {props.filterArray?.map((data) => {
          const { id } = data;
          return (
            <div key={data.id} className={selectedAuthClientID === id ? classes.highlightItemLeft : ''}>
              <ListItem
                id={`list_id_${data.id}`}
                ref={myRefs[data.id]}
                key={data.id}
                button
                selected={selectedAuthClientID === id}
                className={classes.listStyling}
                onClick={(event) => {
                  handleListItemClick(event, data.id);
                }}
              >
                <ListItemText
                  primary={
                    <div>
                      <p
                        className={`
                              ${selectedAuthClientID === id ? classes.listTextSelected : classes.listTextNonSelected}
                            `}
                      >
                        {data.name}
                      </p>
                    </div>
                  }
                />
              </ListItem>
            </div>
          );
        })}
      </List>
      <FloatButton fabs={fabs} value={value} mainTabID={0} onaddNewJourney={addNewAuth} />
      {<ShowProgress />}
      {IsAddnewAuthPopupOpen && (
        <AuthAddNewPopup
          edit={false}
          close={closeAddNewAuth}
          handleClick={(id) => {
            handleListItemClick(0, id);
          }}
        />
      )}
    </div>
  );
};

export default SideBarListAuth;
